import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { TextError } from '.';

export function EmailInput(props) {
    const { label, name, ...rest } = props;
    return (
        <>
            {label && (
                <label htmlFor={name}>
                    {label}{' '}
                    <sup>
                        <FontAwesomeIcon icon={faAsterisk} />
                    </sup>
                </label>
            )}
            <Field name={name}>
                {(props) => {
                    const { field, meta } = props;
                    return (
                        <input
                            className={`form-control ${meta.error && meta.touched ? 'border-error' : ''}`}
                            type="email"
                            id={name}
                            {...field}
                            {...rest}
                        />
                    );
                }}
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </>
    );
}

export default EmailInput;
